// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d54b5be3","455":"b0aa30c8","963":"72df1544","977":"1900550c"}[chunkId] + ".chunk.js";
};